import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { USER_API_URL } from "../../../config";
import { User } from "../types";

export const useUsers = () => {
  return useQuery({
    queryKey: ["users"], // Key used to cache the request
    queryFn: ({ signal }) =>
      axios
        .get(`${USER_API_URL}/waves-user-manager-api/v1/users`, {
          signal
        })
        .then((response) => {
          return response.data as User[];
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
